import React from 'react';
import { PageLayout } from '../components/layout/PageLayout';
import { SEO } from '../components/SEO';

export function PrivacyPolicy() {
  return (
    <PageLayout>
      <SEO 
        title="Privacy Policy - CloseCircle"
        description="Learn about how CloseCircle protects your privacy and handles your personal information."
      />
      <main className="max-w-4xl mx-auto px-6 py-24">
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-8">Privacy Policy</h1>
        
        <div className="prose dark:prose-invert max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Information We Collect</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              We collect information that you provide directly to us, including:
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
              <li>Name and contact information</li>
              <li>Profile information</li>
              <li>Communication preferences</li>
              <li>Location data (with your consent)</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">How We Use Your Information</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
              <li>Provide and improve our services</li>
              <li>Personalize your experience</li>
              <li>Communicate with you</li>
              <li>Ensure platform safety and security</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Data Protection</h2>
            <p className="text-gray-600 dark:text-gray-300">
              We implement robust security measures to protect your personal information, including:
            </p>
            <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
              <li>End-to-end encryption</li>
              <li>Regular security audits</li>
              <li>Strict access controls</li>
              <li>Data minimization practices</li>
            </ul>
          </section>
        </div>
      </main>
    </PageLayout>
  );
}